import { render, staticRenderFns } from "./MenuNotification.vue?vue&type=template&id=30390b88&scoped=true&"
import script from "./MenuNotification.vue?vue&type=script&lang=js&"
export * from "./MenuNotification.vue?vue&type=script&lang=js&"
import style0 from "./MenuNotification.vue?vue&type=style&index=0&id=30390b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30390b88",
  null
  
)

export default component.exports